 (function () {
    $(function () {
        $('.js-carousel-compilations').each(function () {
            const $carousel = $(this);
            const $wrap = $carousel.parents('[data-role="wrap"]');
            const $prev = $wrap.find('[data-role="prev"]');
            const $next = $wrap.find('[data-role="next"]');

            // Init
            let settings = {
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
                dots: true,
                dotsClass: "b-carousel-footer",
                touchThreshold: 10,
                infinite: false,

                responsive: [
                    {
                        breakpoint: globObj.breakpoints.md,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: globObj.breakpoints.lg,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            arrows: true,
                            dots: false
                        }
                    }
                ]
            };

            if ($prev.length > 0) {
                settings.prevArrow = $prev;
            }

            if ($next.length > 0) {
                settings.nextArrow = $next;
            }

            $carousel.slick(settings);
        });
    })

        $(function () {
        $('.js-carousel-big-compilations').each(function () {
            const $carousel = $(this);
            const $wrap = $carousel.parents('[data-role="wrap"]');
            const $prev = $wrap.find('[data-role="prev"]');
            const $next = $wrap.find('[data-role="next"]');

            // Init
            let settings = {
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                dotsClass: "b-carousel-footer",
                touchThreshold: 10,
                infinite: false,

                responsive: [
                    {
                        breakpoint: globObj.breakpoints.md,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: globObj.breakpoints.lg,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            arrows: true,
                            dots: false
                        }
                    }
                ]
            };

            if ($prev.length > 0) {
                settings.prevArrow = $prev;
            }

            if ($next.length > 0) {
                settings.nextArrow = $next;
            }

            $carousel.slick(settings);
        });
    })
}());
